<template>
  <div class="herd-settings">
    <el-form class="form-settings" label-position="top" size="small" label-width="auto" :model="settings">
      <el-form-item label="Odstęp czasu pomiędzy wycieleniami a inseminacją">
        <el-input-number v-model="settings.cai_time_interval" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Powtórka">
        <el-input-number v-model="settings.repetition" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Kontrola cielności">
        <el-input-number v-model="settings.in_calf_control" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Sygnalizacja braku rui">
        <el-input-number v-model="settings.lack_of_estrus" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Długość ciąży">
        <el-input-number v-model="settings.pregnancy_length" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Okres zasuszania">
        <el-input-number v-model="settings.drying_up_time" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Pobyt w porodówce">
        <el-input-number v-model="settings.delivery_room_spend_time" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Wiek jałówki dojrzałej">
        <el-input-number v-model="settings.heifer_mature_age" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="Liczba dni trwania wodzenia">
        <el-input-number v-model="settings.estrus_duration" size="small"></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveSettings">Zapisz zmiany</el-button>
        <el-button type="danger" @click="resetHerdSettings">Przywróć domyślne ustawiania</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { serverAddress } from "../config";

export default {
  mounted: function() {
    this.getSavedSettings();
  },
  data: function() {
    return {
      settings: {
        cai_time_interval: 0,
        repetition: 0,
        in_calf_control: 0,
        lack_of_estrus: 0,
        pregnancy_length: 0,
        drying_up_time: 0,
        delivery_room_spend_time: 0,
        heifer_mature_age: 0,
        estrus_duration: 0
      }
    };
  },
  methods: {
    getSavedSettings() {
      this.getSettings("");
    },
    getDefaultSettings() {
      this.getSettings("/default");
    },
    getSettings(path) {
      axios
        .get(serverAddress + "/api/settings/herd" + path, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.settings = response.data;
            console.log("settings:", response.data);
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },
    saveSettings() {
      this.settings.cai_time_interval = parseInt(
        this.settings.cai_time_interval
      );
      this.settings.repetition = parseInt(this.settings.repetition);
      this.settings.in_calf_control = parseInt(this.settings.in_calf_control);
      this.settings.lack_of_estrus = parseInt(this.settings.lack_of_estrus);
      this.settings.pregnancy_length = parseInt(this.settings.pregnancy_length);
      this.settings.drying_up_time = parseInt(this.settings.drying_up_time);
      this.settings.delivery_room_spend_time = parseInt(
        this.settings.delivery_room_spend_time
      );
      this.settings.heifer_mature_age = parseInt(
        this.settings.heifer_mature_age
      );
      this.settings.estrus_duration = parseInt(this.settings.estrus_duration);

      axios
        .post(serverAddress + "/api/settings/herd", this.settings, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.$message({
              type: "success",
              message: "Pomyślnie zapisano ustawienia"
            });

            console.log(response);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$message({
              type: "error",
              message: "Wystąpił błąd przy zapisie ustawień"
            });

            console.log(error);
          }.bind(this)
        );
    },
    resetHerdSettings() {
      this.$confirm(
        "Czy napewno chcesz przywrócić domyślne ustawienia dla stada?",
        "Uwaga!",
        {
          confirmButtonText: "Tak",
          cancelButtonText: "Anuluj",
          type: "warning"
        }
      )
        .then(() => {
          this.getDefaultSettings();
          this.$message({
            type: "success",
            message: "Pomyślnie przywrócono ustawienia domyślne"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Anulowano przywracanie ustawień domyślnych"
          });
        });
    }
  }
};
</script>

<style>

</style>
